import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReportFilterReport017Service {

  constructor() {
  }

  static generate(filters: any, afilters: any[]): void {
    console.log('filters:',filters);
    if (filters.itemType !== undefined) //
      afilters.push({
        field: 'tipoPeca',
        value: '' + filters.itemType,
        matchMode: 'equals'
      });

    if (filters.actionComunication !== undefined) //
      afilters.push({
        field: 'acaoComunicacao',
        value: '' + filters.actionComunication,
        matchMode: 'equals'
      });

    if(filters.requester !== undefined) //
      afilters.push({
        field: 'solicitante',
        value: '' + filters.requester,
        matchMode: 'contains'
      });
  }

}
